export const DISCORD_LINK_VALIDATION_REGEXP = /http(s)?:\/\/discord\.gg\/[a-zA-Z0-9_]+/i;
export const TELEGRAM_LINK_VALIDATION_REGEXP = /http(s)?:\/\/t\.me\/[a-zA-Z0-9_]+/i;
export const TWITCH_LINK_VALIDATION_REGEXP = /http(s)?:\/\/(www\.)?twitch\.(tv|com)\/[a-zA-Z0-9_]+/i;
export const TWITTER_LINK_VALIDATION_REGEXP = /http(s)?:\/\/twitter\.com\/[a-zA-Z0-9_]+/i;
export const YOUTUBE_LINK_VALIDATION_REGEXP = /http(s)?:\/\/(www\.)?youtube\.com\/[@a-zA-Z0-9_/]+/i;
